// WHETHER A TREE ROW IS IN THE CURRENT SELECTION.
//
// Owner, 2026-10-20: "jsx tree and viewer3d no longer communicate at all".
//
// TreeViewerItem is wrapped in React.memo with a hand-written comparator, and
// that comparator asked `clickedChild.includes(uid)` - a uid STRING against an
// array of element OBJECTS, which is always false. Every row therefore
// compared equal whatever the selection did, so no row re-rendered when the
// selection moved. The row's own highlight has always used
// clickedChild.find(c => c.UniqueId === meshInfo.UniqueId): the comparator and
// the render disagreed about the shape of the same prop.
//
// It stayed invisible because the tree carried key={generateId()} - a uuid -
// so React rebuilt the whole tree every render and rows were recreated from
// scratch. Giving the tree a stable key removed the remount and the stale memo
// surfaced immediately. Two real bugs, one hiding the other.
//
// Pulled out here so the rule is testable without mounting a tree, and so the
// comparator and any future caller cannot drift apart again.

/**
 * True when `list` holds `uid`, whether it holds element objects (the shape
 * the pages actually use) or bare uid strings (older callers).
 */
export function selectionHolds(list, uid) {
  if (!uid || !Array.isArray(list)) return false;
  return list.some((c) => (c && typeof c === 'object' ? c.UniqueId === uid : c === uid));
}
